import { gql } from '@apollo/client';

export const SENSITIVE_ACTION_POLICY_GET = gql`
  query SensitiveActionPolicyGet($actionId: String!, $target: SensitiveActionTargetInput) {
    sensitiveActionPolicyGet(actionId: $actionId, target: $target) {
      actionId
      policyGroup
      principalGroup
      requiredLevel
      isRequired
      isBlocked
      reason
      hasMfaCredential
      hasPasskeyCredential
      confirmationExpiresInSeconds
    }
  }
`;

export const SENSITIVE_ACTION_POLICY_INVENTORY_GET = gql`
  query SensitiveActionPolicyInventoryGet {
    sensitiveActionPolicyInventoryGet {
      definitions {
        actionId
        policyGroup
        userRequiredLevel
        adminRequiredLevel
        adminOnly
        reason
      }
      assignments {
        principalGroup
        requiredLevel
        actionIds
      }
    }
  }
`;

export const SENSITIVE_ACTION_CONFIRMATION_CREATE = gql`
  mutation SensitiveActionConfirmationCreate($input: SensitiveActionConfirmationCreateInput!) {
    sensitiveActionConfirmationCreate(input: $input) {
      actionId
      requiredLevel
      token
      expiresAt
      targetResourceType
      targetResourceId
    }
  }
`;

export const SENSITIVE_ACTION_PASSKEY_CHALLENGE_CREATE = gql`
  mutation SensitiveActionPasskeyChallengeCreate($input: SensitiveActionConfirmationCreateInput!) {
    sensitiveActionPasskeyChallengeCreate(input: $input) {
      challengeId
      expiresAt
      publicKey {
        challenge
        rpId
        timeout
        userVerification
        allowCredentials {
          id
          type
          transports
        }
      }
    }
  }
`;

export const SENSITIVE_ACTION_PASSKEY_CONFIRMATION_VERIFY = gql`
  mutation SensitiveActionPasskeyConfirmationVerify($input: SensitiveActionPasskeyConfirmationVerifyInput!) {
    sensitiveActionPasskeyConfirmationVerify(input: $input) {
      actionId
      requiredLevel
      token
      expiresAt
      targetResourceType
      targetResourceId
    }
  }
`;
